import Bowser from "bowser";
import Services from "../Services";
import {publish} from "./services";

const validatePayload = (payload = {}) => {
  const {service, metadata = {}} = payload,
    {action} = metadata;

  if (!service) {
    console.warn("Payload does not include `service`");
    return false;
  }

  if (!action) {
    console.warn("Payload does not include `metadata.action`");
    return false;
  }

  return true;
};

class Manager {
  constructor() {
    this._ribbonActiveAppId = "";

    this._debugMode = false;
  }

  publish(payload) {
    if (!Services.credentials || Services.isDefaultAccount) {
      return;
    }

    if (!payload.metadata) {
      payload.metadata = {};
    }

    if (Services.isExtension) {
      payload.metadata.browserExtension = true;
    }

    if (Services.isInjected) {
      payload.metadata.browserExtensionWidget = true;
    }

    if (!validatePayload(payload)) {
      console.warn("Telemetry payload validation failed, skipping...");
      return;
    }

    // For metrics run by engineering product management, we provide a single column
    // combining parts of the metadata for easy use in a spreadsheet. For actions that
    // don't have additional detail, copy the action over for consistency
    if (!payload.actionDetail) {
      const {metadata} = payload;
      let actionDetail = metadata.action;

      Object.keys(metadata).forEach(key => {
        if (key === "action") {
          return;
        }

        actionDetail += ` ${key}:${metadata[key]}`;
      });

      /* Not necessary for now, might be useful later if products implement the configutation
      if (Services.integration) {
        Object.keys(Services.integration).forEach(key => {
          actionDetail += ` integration-${key}:${Services.integration[key]}`;
        });
      }
      */

      actionDetail += ` locationHost:${window.location.host}`;

      payload.metadata.actionDetail = actionDetail;
    }

    // Add in the integration info from the product configuration
    if (Services.integration) {
      payload.metadata.integration = Services.integration;
    }

    // Add in Ribbon version
    if (Services.ribbonVersion) {
      payload.metadata.ribbonVersion = Services.ribbonVersion;
    }

    // Add in Active Ribbon app
    if (this._ribbonActiveAppId) {
      payload.metadata.ribbonActiveAppId = this._ribbonActiveAppId;
    }

    // Add in some browser info
    const {language, platform} = window.navigator,
      {origin} = window.location;

    let browserInfo;

    try {
      const browser = Bowser.getParser(window.navigator.userAgent);
      browserInfo = browser.getBrowser();
    } catch (e) {
      // no-op
    }

    payload.metadata.browserData = {language, platform, ...browserInfo};
    payload.metadata.origin = origin;

    if (!payload.metadata.source) {
      payload.metadata.source = "ribbon-services";
    }

    const {promise, cancel} = publish(payload),
      _promise = promise.catch(e => console.error(e));

    if (this._debugMode) {
      console.warn(
        "***Telemetry Published***\n",
        `SERVICE: ${payload.service}\n`,
        `ACTION: ${payload.metadata && payload.metadata.action}\n`,
        payload
      );
    }

    return {promise: _promise, cancel};
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonTelemetryManager) {
    window.atsSecurityRibbonTelemetryManager = new Manager();
  }
  return window.atsSecurityRibbonTelemetryManager;
};

export default Configuration();

export const ManagerClass = Manager;
